import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Top'
import Contact from '@/components/Contact'
import Faq from '@/components/Faq'
import Tos from '@/components/Tos'
import SignUp from '@/components/SignUp'
import Login from '@/components/Login'
import Reset from '@/components/Reset'
import Logout from '@/components/Logout'
import Subscription from '@/components/Subscription'
import UnSubscription from '@/components/UnSubscription'
import Uploaded from '@/components/Uploaded'
import List from '@/components/List'
import Show from '@/components/Show'
import Asct from '@/components/Asct'
import Error from '@/components/Error'
import Adsense from '@/components/Adsense'
import PageNotFound from '@/components/PageNotFound'
import Delete from '@/components/Delete'

Vue.use(Router)
Vue.use(Adsense)

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/asct',
      name: 'Asct',
      component: Asct
    },
    {
      path: '/terms_of_service',
      name: 'Tos',
      component: Tos
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/subscription',
      name: 'Subscription',
      component: Subscription
    },
    {
      path: '/unsubscription',
      name: 'UnSubscription',
      component: UnSubscription
    },
    {
      path: '/uploaded',
      name: 'Uploaded',
      component: Uploaded
    },
    {
      path: '/list',
      name: 'List',
      component: List
    },
    {
      path: '/show/:file_name',
      name: 'Show',
      component: Show
    },
    {
      path: '/error',
      name: 'Error',
      component: Error
    },
    {
      path: '/page_not_found',
      name: 'PageNotFound',
      component: PageNotFound
    },
    {
      path: '/delete',
      name: 'Delete',
      component: Delete
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js